import { useTranslateControlWithParameters } from "@/features/controls/hooks/use-translate-control-with-parameters";
import { useGetControlByIdSuspense } from "@/spz-api/controls/controls";
import type { GetControlByIdResponseDto } from "@/spz-api/model";
import type { TFunction } from "i18next";
import { useMemo } from "react";
import { parseControlDescriptionMarkdown } from "../utils/control-description-parser";

export const useGetControlInformation = ({
  t,
  controlId,
}: { t: TFunction; controlId: string }) => {
  const { data: controlResponse } =
    useGetControlByIdSuspense<GetControlByIdResponseDto>(controlId);

  const relationships = controlResponse.data.relationships;

  const description = useTranslateControlWithParameters(
    {
      name: controlResponse.data.description,
      currency: controlResponse.data.currencyCode,
    },
    relationships.parameters,
  );

  // Parse control description markdown into sections
  // This will return an object with sections containing title and content
  const controlDescription = useMemo(() => {
    return parseControlDescriptionMarkdown(description);
  }, [description]);

  return {
    name: controlResponse.data.name,
    description: controlDescription,
    company: relationships.company,
    controlResultColumns: relationships.controlResultColumns.sort(
      (a, b) => a.displayOrder - b.displayOrder,
    ),
    currency: controlResponse.data.currencyCode,
    analysis: relationships.analysis,
    period: relationships.period,
    parameters: relationships.parameters,
    workflowStats: controlResponse.data.workflowStats.steps,
  };
};
